// Side-by-side layout for overlapping appointments in one column.
// Returns { [apptId]: { lane, lanes } } — `lane` is the 0-based slot within
// the overlap cluster and `lanes` is how many tiles share the width.
export function computeLanes(appts, startOf, durOf) {
  const sorted = [...appts].sort((a, b) => startOf(a) - startOf(b) || String(a.id).localeCompare(String(b.id)));
  const layout = {};
  let laneEnds = [];
  let clusterIds = [];
  const flush = () => {
    const n = laneEnds.length;
    clusterIds.forEach((id) => { layout[id].lanes = n; });
    laneEnds = [];
    clusterIds = [];
  };
  for (const a of sorted) {
    const s = startOf(a);
    const e = s + (durOf(a) || 30);
    if (laneEnds.length && !laneEnds.some((end) => end > s)) flush();
    let lane = laneEnds.findIndex((end) => end <= s);
    if (lane === -1) { lane = laneEnds.length; laneEnds.push(e); } else { laneEnds[lane] = e; }
    layout[a.id] = { lane, lanes: 1 };
    clusterIds.push(a.id);
  }
  flush();
  return layout;
}
